import type React from "react"
import { Close } from "../../icons"
import {
  backgroundVariants,
  borderVariants,
  disabledVariants,
} from "../../styles"
import { classNames } from "../../utils/classNames"
import { TextBody } from "../Text"
import { UnstyledButton, type UnstyledButtonProps } from "../UnstyledButton"

export type PillProps = {
  children: React.ReactNode
  className?: string
  withCloseIcon?: boolean
  ref?: React.Ref<HTMLButtonElement>
} & UnstyledButtonProps

export function Pill({
  children,
  disabled,
  className,
  withCloseIcon = true,
  ...rest
}: PillProps) {
  return (
    <UnstyledButton
      className={classNames(
        "flex h-8 w-fit items-center gap-2 whitespace-nowrap rounded-md p-2",
        backgroundVariants({ background: "primary", interactive: true }),
        borderVariants({ border: "border-1", interactive: true }),
        disabledVariants({ disabled }),
        className,
      )}
      disabled={disabled}
      {...rest}
    >
      <TextBody size="sm" weight="semibold">
        {children}
      </TextBody>

      {withCloseIcon && <Close size={16} />}
    </UnstyledButton>
  )
}
